import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { USER_ROLES, USER_STATUS } from 'src/app/enums/enums';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public user:      User;
  public status:    string;
  public token:     string;
  public identity:  any;
  public options:   any = {
    rememberMe: false,
  };

  constructor(private _userService: UserService, private _router: Router) {
    this.user = new User('', '', '', '', '', USER_ROLES.ADMIN, USER_STATUS.ACTIVE);
  }

  ngOnInit(): void {
    $('html,body').scrollTop(0);
  }

  iniciarSesion(): void {
    if (!this.user.email || !this.user.password) {
      return alert('Por favor, llene todos los campos');
    }
    this._userService.iniciarSesion(this.user).subscribe(
      res => {
        if (!res.token) {
          this.status = 'error';
        } else {
          this.token    = res.token;
          this.identity = res.user;
          if (this.options.rememberMe) {
            localStorage.setItem('token', JSON.stringify(this.token));
            localStorage.setItem('identity', JSON.stringify(this.identity));
          } else {
            sessionStorage.setItem('token', JSON.stringify(this.token));
            sessionStorage.setItem('identity', JSON.stringify(this.identity));
          }
          this.status = 'ok';
          this._router.navigate(['/inicio']);
        }
      },
      error => this.onError(error)
    );
  }

  onError(error: any): void {
    var errorMessage = error;
    alert(error.error.message)
    if (errorMessage != null) {
      this.status = 'error';
    }
  }
}
